/* eslint-disable no-plusplus */
/* eslint-disable import/no-unresolved */
import { Button } from 'appkit-react';
import { useEffect, useState } from 'react';
import { useLazyQuery, useMutation, useQuery } from '@apollo/client';

import { ASSIGN_RULES, UPSERT_RULE } from 'Apollo/Mutations/DataRecon/DataQuality';
import {
    GET_ASSIGNED_RULES, GET_DIMENSIONS, GET_DQ_RULES, GET_FILTER_TYPES, TEST_REGEX,
} from 'Apollo/Queries/DataRecon/DataQuality';
import RulesModal from '../components/RulesModal';

const RuleModalContainer = ({
    showAddRuleModal, setShowAddRuleModal, params, setIsAssignedRulesSaved,
}) => {
    const [ruleId, setRuleId] = useState('');
    const [dimension, setDimension] = useState('');
    const [ruleName, setRuleName] = useState('');
    const [ruleDescription, setRuleDescription] = useState('');
    const [filterExpression, setFilterExpression] = useState('');
    const [filterType, setFilterType] = useState('');
    const [showFields, setShowFields] = useState(false);
    const [fieldsTitle, setfieldsTitle] = useState('');
    const [dimensionError, setDimensionError] = useState(false);
    const [ruleNameError, setRuleNameError] = useState(false);
    const [ruleDescriptionError, setRuleDescriptionError] = useState(false);
    const [filterExpressionError, setFilterExpressionError] = useState(false);
    const [filterTypeError, setFilterTypeError] = useState(false);
    const [selectedRulesForColumn, setSelectedRulesForColumn] = useState([]);
    const [showResetModal, setShowResetModal] = useState(false);
    const [confirmReset, setConfirmReset] = useState(false);
    const [activeAccordionItems, setActiveAccordionItems] = useState(['panel-1']);
    const [validationInput, setValidationInput] = useState(['']);
    const [regExResult, setRegExResult] = useState([]);
    const [currentTab, setCurrentTab] = useState('ASSIGN RULES');
    const [isDataLengthCheckModalvisible, setIsDataLengthCheckModalvisible] = useState(false);
    const [selectedColumn, setSelectedColumn] = useState('');
    const [selectedColumnId, setSelectedColumnId] = useState('');
    const [selectedRuleId, setSelectedRuleId] = useState('');

    const timeOut = 50;

    /* Apollo query to fetch assigned rules  */
    const {
        data: assignedRulesData, loading: assignedRulesLoading, refetch,
    } = useQuery(GET_ASSIGNED_RULES, {
        variables: {
            // projectId: parseInt(JSON.parse(params.project).projectId, 10),
            // uploadId: parseInt(params.uploadId, 10),
            fileName: params.file,
        },
        fetchPolicy: 'no-cache',
    });

    /* Apollo mutation to update assigned rules  */
    const [assignRules, { loading }] = useMutation(ASSIGN_RULES);

    /* Apollo query to fetch dimensions  */
    const dimensions = useQuery(GET_DIMENSIONS, {
        fetchPolicy: 'no-cache',
    });

    /* Apollo query to fetch filterTypes  */
    const filterTypes = useQuery(GET_FILTER_TYPES, {
        fetchPolicy: 'no-cache',
    });

    /* Apollo query to fetch rules  */
    const rules = useQuery(GET_DQ_RULES, {
        variables: {
            projectId: parseInt(JSON.parse(params.project).projectId, 10),
        },
        fetchPolicy: 'no-cache',
    });

    /* Apollo mutation to add/update rule  */
    const [upsertRule, { loading: uperstRuleLoader }] = useMutation(UPSERT_RULE);

    /* Apollo mutation to test regular expression  */
    const [testRegex, { loading: isTestRegexLoading }] = useLazyQuery(TEST_REGEX, {
        onCompleted: data => {
            setRegExResult(data && data.DQtestRegex);
        },
        fetchPolicy: 'no-cache',
    });

    /* Function to call assignRule Mutation  */
    const updateColumnConfig = async config => {
        await assignRules({
            variables: {
                assignedRules: [...config],
                fileName: params.file,
            },
        });
        refetch();
        setIsAssignedRulesSaved(true);
        setTimeout(() => {
            setShowAddRuleModal(false);
        }, timeOut);
    };

    // Show empty fields to add new rule
    const onAddNewRule = () => {
        setRuleId('');
        setDimension('');
        setRuleName('');
        setRuleDescription('');
        setFilterExpression('');
        setFilterType('');
        setfieldsTitle('ADD RULE');
        setShowFields(true);
        setActiveAccordionItems(['panel-2']);
    };

    // Show fields with data to edit new rule
    const onRuleEdit = rule => {
        setRuleId(rule.ruleId);
        setDimension(rule.dimensionId);
        setRuleName(rule.ruleName);
        setRuleDescription(rule.ruleDescription);
        setFilterExpression(rule.filterExpression);
        setFilterType(rule.filterTypeId);
        setfieldsTitle('EDIT RULE');
        setShowFields(true);
        setActiveAccordionItems(['panel-2']);
    };

    // form validations
    const validateForm = () => {
        if (ruleName.trim() === '' || ruleName.trim() === null) {
            setRuleNameError(true);
        } else {
            setRuleNameError(false);
        }
        if (filterExpression.trim() === '' || filterExpression.trim() === null) {
            setFilterExpressionError(true);
        } else {
            setFilterExpressionError(false);
        }
        if (dimension === '' || dimension === null) {
            setDimensionError(true);
        } else {
            setDimensionError(false);
        }
        if (filterType === '' || filterType === null) {
            setFilterTypeError(true);
        } else {
            setFilterTypeError(false);
        }
        if (ruleDescription === '' || ruleDescription === null) {
            setRuleDescriptionError(true);
        } else {
            setRuleDescriptionError(false);
        }
    };

    const isValidFilter = () => (!filterTypeError && !filterExpressionError);

    const isValidRule = () => (!ruleNameError && !ruleDescriptionError);

    // save action for Manage Rule tab
    const onTabOneSave = async () => {
        validateForm();
        if (!dimensionError && isValidFilter() && isValidRule()) {
            if (fieldsTitle === 'EDIT RULE') {
                await upsertRule({
                    variables: {
                        ruleId,
                        ruleName,
                        ruleDescription,
                        filterExpression,
                        dimensionId: dimension,
                        filterTypeId: filterType,
                        projectId: parseInt(JSON.parse(params.project).projectId, 10),
                    },
                });
                rules.refetch();
                setActiveAccordionItems(['panel-1']);
                setRuleId('');
                setDimension('');
                setRuleName('');
                setRuleDescription('');
                setFilterExpression('');
                setFilterType('');
                setShowFields(false);
                setValidationInput(['']);
            }
            if (fieldsTitle === 'ADD RULE') {
                await upsertRule({
                    variables: {
                        ruleName,
                        filterExpression,
                        ruleDescription,
                        dimensionId: dimension,
                        filterTypeId: filterType,
                        projectId: parseInt(JSON.parse(params.project).projectId, 10),
                        ruleId: parseInt(ruleId, 10),
                    },
                });
                rules.refetch();
                setActiveAccordionItems(['panel-1']);
                setRuleId('');
                setDimension('');
                setRuleName('');
                setRuleDescription('');
                setFilterExpression('');
                setFilterType('');
                setShowFields(false);
                setValidationInput(['']);
            }
        }
    };

    // Getter for dimentionName
    const getDimensionName = dimensionId => {
        let result;
        if (dimensions.data && dimensions.data.DQgetDimensions) {
            result = dimensions.data.DQgetDimensions.find(d => d.dimensionId === dimensionId);
        }
        return result ? result.dimensionName : '';
    };

    // Getter for filterType
    const getFilterType = filterTypeId => {
        let result;
        if (filterTypes.data && filterTypes.data.DQgetFilterTypes) {
            result = filterTypes.data.DQgetFilterTypes.find(type => type.filterTypeId === filterTypeId);
        }
        return result ? result.filterType : '';
    };

    const onModalClose = () => {
        if (currentTab === 'ASSIGN RULES') {
            setShowResetModal(true);
        } else {
            setShowAddRuleModal(false);
        }
    };

    // Column configuration for rules table
    const tableColumns = [
        {
            Header: 'Name',
            accessor: 'ruleName',
            minWidth: 40,
            resizable: true,
        },
        {
            Header: 'Description',
            accessor: 'ruleDescription',
            minWidth: 70,
            resizable: true,
            Cell: ({ original }) => (
                <span>
                    {original.ruleDescription.charAt(0).toUpperCase() + original.ruleDescription.slice(1)}
                </span>
            ),
        },
        {
            Header: 'Dimension',
            accessor: '_',
            minWidth: 40,
            resizable: true,
            Cell: ({ original }) => {
                const str = getDimensionName(original.dimensionId);
                return (
                    <span>
                        {str.charAt(0).toUpperCase() + str.slice(1)}
                    </span>
                );
            },
        },
        {
            Header: 'Filter type',
            accessor: '_',
            minWidth: 30,
            resizable: true,
            Cell: ({ original }) => {
                const str = getFilterType(original.filterTypeId);
                return (
                    <span>
                        {str.charAt(0).toUpperCase() + str.slice(1)}
                    </span>
                );
            },
        },
        {
            Header: 'Filter expression',
            accessor: 'filterExpression',
            minWidth: 120,
            resizable: true,
        },
        {
            Header: '',
            accessor: '',
            minWidth: 20,
            resizable: true,
            Cell: ({ original }) => {
                if (original.editable === true) {
                    return (
                        <Button
                            kind="secondary"
                            style={{ marginTop: '0.3rem' }}
                            onClick={() => onRuleEdit(original)}
                        >
                            Edit
                        </Button>
                    );
                }
                return '';
            },
        },
    ];

    /** Side effect when assignedRulesData changes */
    useEffect(() => {
        if (assignedRulesData && assignedRulesData.DQgetAssignedRules) {
            const selectedRulesForCol = assignedRulesData.DQgetAssignedRules.slice();
            setSelectedRulesForColumn(selectedRulesForCol);
        }
    }, [assignedRulesData]);

    /** Side effect when user confirms to close and reset the selection of Manage Rules Tab */
    useEffect(() => {
        if (confirmReset) {
            setSelectedRulesForColumn(assignedRulesData.DQgetAssignedRules.slice());
            setConfirmReset(false);
        }
        return () => {
            setShowAddRuleModal(false);
        };
    }, [confirmReset]);

    const handleValidationInput = (value, index) => {
        const tempData = [...validationInput];
        tempData[index] = value;
        setValidationInput(tempData);
    };

    const onValidateRule = async () => {
        setRegExResult([]);
        await testRegex({
            variables: {
                regex: filterExpression,
                inputs: validationInput,
            },
        });
    };

    const onAddNewInput = () => {
        setValidationInput([...validationInput, '']);
    };

    const onRemoveInput = ind => {
        const result = [];
        const tempRegExResult = [];
        for (let index = 0; index < validationInput.length; index++) {
            if (index !== ind) {
                result.push(validationInput[index]);
                tempRegExResult.push(regExResult[index]);
            }
        }
        setValidationInput(result);
        setRegExResult(tempRegExResult);
    };

    return (
        <RulesModal
            showAddRuleModal={showAddRuleModal}
            setShowAddRuleModal={setShowAddRuleModal}
            selectedRulesForColumn={selectedRulesForColumn}
            setSelectedRulesForColumn={setSelectedRulesForColumn}
            updateColumnConfig={updateColumnConfig}
            assignedRulesLoading={assignedRulesLoading}
            assignRulesLoading={loading}
            dimensions={dimensions}
            filterTypes={filterTypes}
            uperstRuleLoader={uperstRuleLoader}
            rules={rules}
            dimension={dimension}
            setDimension={setDimension}
            ruleName={ruleName}
            setRuleName={setRuleName}
            ruleDescription={ruleDescription}
            setRuleDescription={setRuleDescription}
            filterExpression={filterExpression}
            setFilterExpression={setFilterExpression}
            filterType={filterType}
            setFilterType={setFilterType}
            showFields={showFields}
            fieldsTitle={fieldsTitle}
            dimensionError={dimensionError}
            ruleNameError={ruleNameError}
            ruleDescriptionError={ruleDescriptionError}
            filterExpressionError={filterExpressionError}
            filterTypeError={filterTypeError}
            onAddNewRule={onAddNewRule}
            onTabOneSave={onTabOneSave}
            tableColumns={tableColumns}
            onModalClose={onModalClose}
            showResetModal={showResetModal}
            setShowResetModal={setShowResetModal}
            setConfirmReset={setConfirmReset}
            activeAccordionItems={activeAccordionItems}
            validationInput={validationInput}
            handleValidationInput={handleValidationInput}
            onValidateRule={onValidateRule}
            addNewInput={onAddNewInput}
            regExResult={regExResult}
            isTestRegexLoading={isTestRegexLoading}
            removeInput={onRemoveInput}
            setCurrentTab={setCurrentTab}
            currentTab={currentTab}
            isDataLengthCheckModalvisible={isDataLengthCheckModalvisible}
            setIsDataLengthCheckModalvisible={setIsDataLengthCheckModalvisible}
            selectedColumn={selectedColumn}
            setSelectedColumn={setSelectedColumn}
            selectedColumnId={selectedColumnId}
            setSelectedColumnId={setSelectedColumnId}
            selectedRuleId={selectedRuleId}
            setSelectedRuleId={setSelectedRuleId}
        />
    );
};

export default RuleModalContainer;
